module.exports = "/timeclock/components/viewTimesheetGroupComponent-cbf07e.html";